// hooks/useCreateCampaign.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateCampaignParams } from "@/types/campaign";
import { createCampaign } from "@/services/rest/campaign-service";

export const useCreateCampaign = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (params?: Partial<CreateCampaignParams>) => {
      const payload: CreateCampaignParams = {
        campaign_name: params?.campaign_name ?? "",
      } as CreateCampaignParams;
      const response = await createCampaign(payload);
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["campaigns"] });
    },
  });
};
